import { GridColDef } from '@mui/x-data-grid-premium'
import { SensorBatteryStats } from 'src/api'
import { InnerLink } from 'src/components/ui'

export namespace SensorBatteryStatsListColumns {
  export const IMEI: GridColDef<SensorBatteryStats> = {
    field: 'imei',
    headerName: 'IMEI',
    type: 'string',
    minWidth: 180,
    editable: false,
    renderCell: ({ value }) => (value ? <InnerLink to={`/sensors/${value}`}>{value}</InnerLink> : '-')
  }

  export const BatteryStartValue: GridColDef<SensorBatteryStats> = {
    field: 'batteryStartValue',
    headerName: 'Battery Start Value',
    type: 'number',
    minWidth: 160,
    editable: false,
    valueFormatter: ({ value }) => value || '-'
  }

  export const DaysSinceLastCharge: GridColDef<SensorBatteryStats> = {
    field: 'daysSinceLastCharge',
    headerName: 'Days Since Last Charge',
    type: 'number',
    minWidth: 180,
    editable: false,
    valueFormatter: ({ value }) => value || '-'
  }

  export const CurrentBattery: GridColDef<SensorBatteryStats> = {
    field: 'currentBattery',
    headerName: 'Current Battery Value',
    type: 'number',
    minWidth: 170,
    editable: false,
    valueFormatter: ({ value }) => value || '-'
  }

  export const DailyDischargeRate: GridColDef<SensorBatteryStats> = {
    field: 'dailyDischargeRate',
    headerName: 'Daily Discharge Rate',
    type: 'number',
    minWidth: 170,
    editable: false,
    valueFormatter: ({ value }) => value || '-'
  }

  export const MaxHourlyDeviation: GridColDef<SensorBatteryStats> = {
    field: 'maxHourlyDeviation',
    headerName: 'Max Hourly Deviation',
    type: 'number',
    minWidth: 170,
    editable: false,
    valueFormatter: ({ value }) => value || '-'
  }

  export const EstimatedDaysRemaining: GridColDef<SensorBatteryStats> = {
    field: 'estimatedDaysRemaining',
    headerName: 'Estimated Days Remaining',
    type: 'string',
    minWidth: 200,
    editable: false,
    valueGetter: ({ row }) => {
      if (!row.dailyDischargeRate || !row.estimatedDaysRemaining) {
        return 'n/a'
      }
      return row.estimatedDaysRemaining
    }
  }

  export const BleConfiguration: GridColDef<SensorBatteryStats> = {
    field: 'configuration.ble',
    headerName: 'BLE',
    type: 'string',
    minWidth: 170,
    editable: false,
    valueGetter: ({ row }) => row.configuration?.ble || null,
    valueFormatter: ({ value }) => (value ? (value.enabled ? value.value : 'off') : '-')
  }

  export const LocationConfiguration: GridColDef<SensorBatteryStats> = {
    field: 'configuration.location',
    headerName: 'Location',
    type: 'string',
    minWidth: 170,
    editable: false,
    valueGetter: ({ row }) => row.configuration?.location || null,
    valueFormatter: ({ value }) => (value ? (value.enabled ? value.value : 'off') : '-')
  }

  export const TemperatureConfiguration: GridColDef<SensorBatteryStats> = {
    field: 'configuration.temperature',
    headerName: 'Temperature',
    type: 'string',
    minWidth: 170,
    editable: false,
    valueGetter: ({ row }) => row.configuration?.temperature || null,
    valueFormatter: ({ value }) => (value ? (value.enabled ? value.value : 'off') : '-')
  }

  export const HumidityConfiguration: GridColDef<SensorBatteryStats> = {
    field: 'configuration.humidity',
    headerName: 'Humidity',
    type: 'string',
    minWidth: 170,
    editable: false,
    valueGetter: ({ row }) => row.configuration?.humidity || null,
    valueFormatter: ({ value }) => (value ? (value.enabled ? value.value : 'off') : '-')
  }

  export const PressureConfiguration: GridColDef<SensorBatteryStats> = {
    field: 'configuration.pressure',
    headerName: 'Pressure',
    type: 'string',
    minWidth: 170,
    editable: false,
    valueGetter: ({ row }) => row.configuration?.pressure || null,
    valueFormatter: ({ value }) => (value ? (value.enabled ? value.value : 'off') : '-')
  }

  export const LightConfiguration: GridColDef<SensorBatteryStats> = {
    field: 'configuration.light',
    headerName: 'Light',
    type: 'string',
    minWidth: 170,
    editable: false,
    valueGetter: ({ row }) => row.configuration?.light || null,
    valueFormatter: ({ value }) => (value ? (value.enabled ? value.value : 'off') : '-')
  }

  export const AccelerometerConfiguration: GridColDef<SensorBatteryStats> = {
    field: 'configuration.accelerometer',
    headerName: 'Accelerometer',
    type: 'string',
    minWidth: 170,
    editable: false,
    valueGetter: ({ row }) => row.configuration?.accelerometer || null,
    valueFormatter: ({ value }) => (value ? (value.enabled ? value.value : 'off') : '-')
  }

  export const GyroConfiguration: GridColDef<SensorBatteryStats> = {
    field: 'configuration.gyro',
    headerName: 'Gyro',
    type: 'string',
    minWidth: 170,
    editable: false,
    valueGetter: ({ row }) => row.configuration?.gyro || null,
    valueFormatter: ({ value }) => (value ? (value.enabled ? value.value : 'off') : '-')
  }

  export const BatteryConfiguration: GridColDef<SensorBatteryStats> = {
    field: 'configuration.battery',
    headerName: 'Battery',
    type: 'string',
    minWidth: 170,
    editable: false,
    valueGetter: ({ row }) => row.configuration?.battery || null,
    valueFormatter: ({ value }) => (value ? (value.enabled ? value.value : 'off') : '-')
  }

  export const SignalStrengthConfiguration: GridColDef<SensorBatteryStats> = {
    field: 'configuration.signalStrength',
    headerName: 'Signal Strength',
    type: 'string',
    minWidth: 170,
    editable: false,
    valueGetter: ({ row }) => row.configuration?.signalStrength || null,
    valueFormatter: ({ value }) => (value ? (value.enabled ? value.value : 'off') : '-')
  }
}
